import { isArray } from 'util';
import { ToolTemplate } from '../tool-template';
import { ToolTemplateToolBuilder } from './tool-template-tool.builder';

export class ToolTemplateBuilder {
  static fromJson(json) {
    return (json)
      ? new ToolTemplate(
        json.hash,
        json.name,
        json.description,
        ToolTemplateToolBuilder.fromList(json.tools)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ToolTemplateBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/tool-template.builder.ts